var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('chartjs-component-doughnut-chart',{attrs:{"height":200,"data":_vm.data,"options":_vm.options},on:{"itemclicked":_vm.clickedItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }